<div class="mt-5">
    <app-about-block></app-about-block>
    <h1 class="text-center mt-5">And this is just the beginning <span class="highlight">.</span><span class="highlight-two">.</span><span class="highlight-three">.</span></h1>
    <p class="text-center subheading">If you would like to stay up to date with what I learn on this journey and continue upskilling yourself make sure you sign-up for my weekly newsletter</p>
    <div class="text-center mt-3 mb-5">
        <button type="button" class="btn btn-brand" routerLink="">Sign-up Here</button>
    </div>
</div>